export { Toggle, ToggleProps } from '@ui-kitten/components';
